function todayIso(): string {
  return new Date().toISOString().slice(0, 10)
}

export function daysUntilExpiry(isoDate: string | null): number | null {
  if (!isoDate) return null
  const today = new Date(todayIso())
  const then = new Date(isoDate)
  const ms = then.getTime() - today.getTime()
  if (Number.isNaN(ms)) return null
  return Math.floor(ms / (24 * 3600 * 1000))
}

export function isExpiringSoon(
  isoDate: string | null,
  windowDays = 30,
): boolean {
  const days = daysUntilExpiry(isoDate)
  if (days === null) return false
  return days >= 0 && days <= windowDays
}

export function isOutOfStock(qty: { qty_available: number | null }): boolean {
  // null qty_available is treated as not-out-of-stock — we can't
  // prove the row is out-of-stock without data, so don't flag it.
  // Matches the render path which shows "—" rather than flagging.
  if (qty.qty_available == null) return false
  return qty.qty_available <= 0
}
